import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mto_component_option_compatibility_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  component1 : fromDatatype.GuidDataFieldInterface;
  component2 : fromDatatype.GuidDataFieldInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_mto_component_option_compatibility_hdr_RowClass implements bl_fi_mto_component_option_compatibility_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  mto_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  component1 : fromDatatype.GuidDataFieldInterface;
  component2 : fromDatatype.GuidDataFieldInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
